<script setup lang="ts">
  import SidebarLink from '~/components/UI/Utilities/SidebarLink.vue';
  import SidebarSection from '~/components/UI/Utilities/SidebarSection.vue';
  const { isExpenseEnabled } = useAuth();
</script>

<template>
  <div class="flex h-[calc(100vh-55px)]">
    <div class="!w-[300px] px-2 border-r border-zinc-200">
      <SidebarSection title="Tally Integration">
        <SidebarLink :to="'/utilities'" label="Export to Tally - Income" />
        <SidebarLink
          v-if="isExpenseEnabled"
          :to="'/utilities/export_tally_expense'"
          label="Export to Tally - Expense"
        />
        <SidebarLink v-if="isExpenseEnabled" :to="'/utilities/expense_reconciliation'" label="Expense Reconciliation" />
        <SidebarLink
          v-if="isExpenseEnabled"
          :to="'/utilities/expense_reconciliation_status'"
          label="Expense Reconciliation Status"
        />
      </SidebarSection>
      <SidebarSection title="Imports">
        <SidebarLink :to="'/utilities/import_donations'" label="Import Donations" />
        <SidebarLink v-if="isExpenseEnabled" :to="'/utilities/import_payee'" label="Import Payee" />
        <SidebarLink :to="'/utilities/import_ledgers'" label="Import Ledgers" />
        <SidebarLink v-if="isExpenseEnabled" :to="'/utilities/import_payments'" label="Import Payments" />
      </SidebarSection>
      <SidebarSection title="Exports">
        <SidebarLink :to="'/utilities/statutory_reports'" label="Form 10BD" />
        <SidebarLink :to="'/utilities/10be_emailer'" label="10BE Emailer" />
        <SidebarLink :to="'/utilities/tax_audit'" label="Tax Audit - Substantial Donors" />
        <SidebarLink :to="'/utilities/download_formats'" label="Download Formats" />
        <SidebarLink :to="'/utilities/grant_wise_attachments_download'" label="Grant Wise Attachments Download" />
      </SidebarSection>
    </div>
    <div class="w-[calc(100%-300px)]">
      <slot />
    </div>
  </div>
</template>
